// Visitor heartbeat beacon. Pings the widget-health endpoint on a successful
// mount and on caught mount/render errors. Failures are swallowed — the beacon
// must never affect the visitor experience.
export function sendHeartbeat(restConfig, status, message) {
  const url = restConfig && restConfig.heartbeatUrl;
  if (!url) return;
  try {
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-WP-Nonce": (restConfig && restConfig.nonce) || "",
      },
      body: JSON.stringify({ status: status || "mounted", message: message || "" }),
      keepalive: true,
    }).catch(() => {});
  } catch (e) {
    /* no-op */
  }
}
